export default "__VITE_ASSET__DJ9zF2nh__"